export default __webpack_public_path__ + "static/media/key.04aeea7a.svg";